import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { 
    CircleCheck,
    Clock,
    Mail,
    Plus
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import PopupButton from "components/button/PopupButton";
import MessageTicket from "./components/MessageTicket";
import EmployeeInboxTabs from "./components/EmployeeInboxTabs";
import DepartmentGridCard from "./components/DepartmentCardGrid";
import {
    getTicketList 
} from "../../../../../redux/ticket/ticketState";
import {
    getDepartmentList
} from "../../../../../redux/optionlist/optionlistState";

const getStatusDisplay = (status) => ({
    "open": "pending",
    "in progress": "responded",
    "resolved": "resolved"
}[status] || "pending");

const EmployeeInbox = ({
    doSearch,
    pagination,
    recordList = [],
    getDepartment,
    departmentList
}) => {
    const [selectedDepartment, setSelectedDepartment] = useState("All");

    const mainTickets = (recordList || []).filter(t => !t.tic_parent_id);

    const total = mainTickets.length;
    const pending = mainTickets.filter(t => t.ticket_status === 'open').length;
    const resolved = mainTickets.filter(t => t.ticket_status === 'resolved').length;

    useEffect(() => {
        doSearch({
            paginate: pagination.per_page,
        });
    }, [doSearch, pagination.per_page]);

    useEffect(() => {
        getDepartment();
    }, [getDepartment]);

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"My Inbox"}
                    icon={Mail}
                    description={"Connect with Hyvid departments for support and assistance"}
                    color={"bg-emerald"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Contact Hyvid Department"
                            description="Send a message to any Hyvid department for support and assistance"
                            label="New Message" 
                            btnClass="ticket btn-ticket white" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <MessageTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Total Messages"
                            icon={<Mail />}
                            display={total}
                        />
                        <SummaryItem
                            title="Pending"
                            icon={<Clock />}
                            display={pending} 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display={resolved}
                        />
                   </div>
                </SummaryHeader>
                <DepartmentGridCard 
                    messages={recordList}
                    selectedDepartment={selectedDepartment}
                    onSelectDepartment={setSelectedDepartment}
                    departmentOptions={departmentList}
                />
                <EmployeeInboxTabs 
                    messages={recordList}
                    selectedDepartment={selectedDepartment}
                    getStatusDisplay={getStatusDisplay}
                />
            </div>
        </div>
    )
};

const mapStateToProps = (state) => ({
    recordList: state.ticket.ticketList?.items,
    pagination: state.ticket.ticketList?.pagination,
    filters: state.ticket.ticketList?.filters,
    departmentList: state.optionlist.departmentList?.items,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTicketList(filters)),
    getDepartment: (data) => dispatch(getDepartmentList(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeInbox);